module.exports = __webpack_public_path__ + "img/logo-m2n.cfd26f9d.svg";